import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";
import { accessRole } from "../../../../../../helpers/access_role";
import { Preview } from "../../../../../../helpers/ui/FileInput";
import CustomSelect from "../../../../../../helpers/ui/CustomSelect";
import { ConfirmAlert } from "../../../../../../helpers/ui/alert";

import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";

import { Link, Redirect } from "react-router-dom";
import apiResponse from "../../../../../../services/apiResponse";

import { cancelToken } from "../../../../../../services/adapters/kepegawaian/diklatService";
// import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar'

import UpdateBloc from "../Update/Blocs/UpdateBloc";
import IndexBloc from "../Index/Blocs/DiklatBloc";
import moment from "moment";

const urlParams = new URLSearchParams(window.location.search);
const uuid = urlParams.get("uuid");

class DetailView extends Component {
  // Retrieve Data Pegawai by Admin / Pegawai
  userdata = JSON.parse(localStorage.getItem("userdata"));
  employeeSeleted = JSON.parse(localStorage.getItem("employeeSelected"));
  peg_uuid = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_uuid
      : ""
    : this.employeeSeleted != null
    ? this.employeeSeleted.employee_uuid
    : "";

  source;
  indexBloc = new IndexBloc();
  updateBloc = new UpdateBloc();

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      detail: [],
      history: [],
      trainingOption: [],
      modal: false,
      trainingFilter: {
        filter_value: "",
        page_number: 1,
        page_size: 50,
        sort_order: {
          column: "training_type_sort",
          order: "asc",
        },
      },
      hoursDetail: {},
      type: 1,
      typename: "Teknis",
      peg_uuid: "",
    };
  }

  dateParse = (input) => {
    let res = "-";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  toggleModal = () => {
    this.setState({ modal: !this.state.modal });
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        // training_uuid: this.props.uuid,
        training_uuid: uuid,
        // training_employee_uuid: this.peg_uuid,
        training_employee_uuid: this.state.peg_uuid,
        // training_type: this.props.type,
        training_type: "Teknis",
        ...values,
      },
      confirm: true,
    });
  };

  submitData = async () => {
    console.log(this.state.dataForm);
    await this.indexBloc.fetchApprove(this.state.dataForm);
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  loadTraining = async () => {
    let offset =
      (this.state.trainingFilter.page_number - 1) *
      this.state.trainingFilter.page_size;
    const query = {
      // type: this.props.type,
      type: "Teknis",
      search: this.state.trainingFilter.filter_value,
      limit: this.state.trainingFilter.page_size,
      offset: offset,
      order: this.state.trainingFilter.sort_order.column,
      sort: this.state.trainingFilter.sort_order.order,
      status: 1,
    };
    await this.updateBloc.fetchTrainingList(query, this.source.token);
  };

  loadDetail = async () => {
    const query = {
      // uuid: this.uuid,
      uuid: uuid,
      history: 1,
    };
    await this.updateBloc.fetchDetail(query, this.source.token);
    this.loadHours();
  };

  loadHours = async () => {
    const query = {
      // uuid: this.props.uuid,
      uuid: uuid,
      employee_uuid: this.state.peg_uuid,
    };
    await this.indexBloc.fetchHours(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadTraining();
    this.loadDetail();
    // this.loadHours()
  };

  componentDidMount() {
    this.setTokenAPI();

    this.indexBloc.hoursChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            hoursDetail: result.data.response,
          });
          break;
        default:
          break;
      }
    });

    this.updateBloc.trainingListChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            trainingOption: result.data.response.result,
          });
          break;

        default:
          break;
      }
    });

    this.updateBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            detail: result.data.response.current,
            history: result.data.response.history,
            peg_uuid:
              result.data.response.current.detail?.training_employee_uuid,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.approveChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
    console.log(uuid + " ini uuid");
  }

  componentWillUnmount() {
    this.updateBloc.detailChannel?.unsubscribe();
    this.updateBloc.approveChannel?.unsubscribe();
    this.updateBloc.trainingListChannel?.unsubscribe();
  }

  render() {
    const { type } = this.props;
    const { result, detail } = this.state.detail;
    const { hresult, hdetail } = this.state.history;
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              {/* <PegawaiSideBar active={`diklat&type=${type}`} /> */}

              <Card className="">
                <CardBody>
                  <div className="float-end">
                    <Link to={`?index`}>
                      <Button outline color="primary">
                        <i className="uil uil-backward"></i> Kembali
                      </Button>
                    </Link>
                  </div>
                  <CardTitle>Approve Diklat {type}</CardTitle>
                  <hr />

                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    {hdetail ? (
                      <Row className="mb-3">
                        <label className="col-md-3"></label>
                        <Col md="5">
                          <strong> Data Baru </strong>
                        </Col>
                        <Col md="4">
                          <strong className="text-danger"> Data Lama </strong>
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}

                    <Row className="mb-2">
                      <Label className="col-md-3 col-form-label">Pegawai</Label>
                      <Label className="col-md-5 col-form-label">
                        {result?.training_employee_full_name}
                      </Label>
                      <Label
                        className={`col-md-4 col-form-label ${
                          hdetail != null ? "" : "hidden"
                        }`}
                      >
                        {hresult && hresult?.training_employee_full_name}
                      </Label>
                    </Row>
                    <Row className="mb-2">
                      <Label className="col-md-3 col-form-label">
                        Nama Diklat
                      </Label>
                      <Label className="col-md-5 col-form-label">
                        {result?.training_type_name}
                      </Label>
                      <Label
                        className={`col-md-4 col-form-label ${
                          hdetail != null ? "" : "hidden"
                        }`}
                      >
                        {hresult && hresult?.training_type_name}
                      </Label>
                    </Row>
                    <Row className="mb-2">
                      <Label className="col-md-3 col-form-label">
                        Luar / Dalam Negeri
                      </Label>
                      <Label className="col-md-5 col-form-label">
                        {detail?.training_domicile
                          ? "Luar Negeri"
                          : "Dalam Negeri"}
                      </Label>
                      <Label
                        className={`col-md-4 col-form-label ${
                          hdetail != null ? "" : "hidden"
                        }`}
                      >
                        {hdetail?.training_domicile
                          ? "Luar Negeri"
                          : "Dalam Negeri"}
                      </Label>
                    </Row>
                    {detail?.training_domicile === 0 ? (
                      <Fragment>
                        <Row className="mb-2">
                          <Label className="col-md-3 col-form-label">
                            Provinsi
                          </Label>
                          <Label className="col-md-5 col-form-label">
                            {result?.training_province_name}
                          </Label>
                          <Label
                            className={`col-md-4 col-form-label ${
                              hdetail != null ? "" : "hidden"
                            }`}
                          >
                            {hresult?.training_province_name}
                          </Label>
                        </Row>
                        <Row className="mb-2">
                          <Label className="col-md-3 col-form-label">
                            Kota
                          </Label>
                          <Label className="col-md-5 col-form-label">
                            {result?.training_city_name}
                          </Label>
                          <Label
                            className={`col-md-4 col-form-label ${
                              hdetail != null ? "" : "hidden"
                            }`}
                          >
                            {hresult?.training_city_name}
                          </Label>
                        </Row>
                      </Fragment>
                    ) : (
                      <Fragment>
                        <Row className="mb-2">
                          <Label className="col-md-3 col-form-label">
                            Negara
                          </Label>
                          <Label className="col-md-5 col-form-label">
                            {result?.training_country_name}
                          </Label>
                          <Label
                            className={`col-md-4 col-form-label ${
                              hdetail != null ? "" : "hidden"
                            }`}
                          >
                            {hresult?.training_country_name}
                          </Label>
                        </Row>
                        <Row className="mb-2">
                          <Label className="col-md-3 col-form-label">
                            Kota
                          </Label>
                          <Label className="col-md-5 col-form-label">
                            {result?.training_city_text}
                          </Label>
                          <Label
                            className={`col-md-4 col-form-label ${
                              hdetail != null ? "" : "hidden"
                            }`}
                          >
                            {hresult?.training_city_text}
                          </Label>
                        </Row>
                      </Fragment>
                    )}
                    <Row className="mb-2">
                      <Label className="col-md-3 col-form-label">
                        Penyelenggara
                      </Label>
                      <Label className="col-md-5 col-form-label">
                        {result?.training_organizer}
                      </Label>
                      <Label
                        className={`col-md-4 col-form-label ${
                          hdetail != null ? "" : "hidden"
                        }`}
                      >
                        {hresult?.training_organizer}
                      </Label>
                    </Row>
                    <Row className="mb-2">
                      <Label className="col-md-3 col-form-label">
                        Angkatan
                      </Label>
                      <Label className="col-md-5 col-form-label">
                        {result?.training_generation}
                      </Label>
                      <Label
                        className={`col-md-4 col-form-label ${
                          hdetail != null ? "" : "hidden"
                        }`}
                      >
                        {hresult?.training_generation}
                      </Label>
                    </Row>
                    <Row className="mb-2">
                      <Label className="col-md-3 col-form-label">Tahun</Label>
                      <Label className="col-md-5 col-form-label">
                        {result?.training_year}
                      </Label>
                      <Label
                        className={`col-md-4 col-form-label ${
                          hdetail != null ? "" : "hidden"
                        }`}
                      >
                        {hresult?.training_year}
                      </Label>
                    </Row>
                    <Row className="mb-2">
                      <Label className="col-md-3 col-form-label">
                        Tanggal Mulai
                      </Label>
                      <Label className="col-md-5 col-form-label">
                        {this.dateParse(result?.training_start_date)}
                      </Label>
                      <Label
                        className={`col-md-4 col-form-label ${
                          hdetail != null ? "" : "hidden"
                        }`}
                      >
                        {this.dateParse(hresult?.training_start_date)}
                      </Label>
                    </Row>
                    <Row className="mb-2">
                      <Label className="col-md-3 col-form-label">
                        Tanggal Selesai
                      </Label>
                      <Label className="col-md-5 col-form-label">
                        {this.dateParse(result?.training_end_date)}
                      </Label>
                      <Label
                        className={`col-md-4 col-form-label ${
                          hdetail != null ? "" : "hidden"
                        }`}
                      >
                        {this.dateParse(hresult?.training_end_date)}
                      </Label>
                    </Row>
                    <Row className="mb-2">
                      <Label className="col-md-3 col-form-label">No STTP</Label>
                      <Label className="col-md-5 col-form-label">
                        {result?.training_sttpp_number}
                      </Label>
                      <Label
                        className={`col-md-4 col-form-label ${
                          hdetail != null ? "" : "hidden"
                        }`}
                      >
                        {hresult?.training_sttpp_number}
                      </Label>
                    </Row>
                    <Row className="mb-2">
                      <Label className="col-md-3 col-form-label">
                        Tanggal STTP
                      </Label>
                      <Label className="col-md-5 col-form-label">
                        {this.dateParse(result?.training_sttpp_date)}
                      </Label>
                      <Label
                        className={`col-md-4 col-form-label ${
                          hdetail != null ? "" : "hidden"
                        }`}
                      >
                        {this.dateParse(hresult?.training_sttpp_date)}
                      </Label>
                    </Row>
                    <Row>
                      <Label className="col-md-3 col-form-label">
                        Jumlah Jam
                      </Label>
                      <Label className="col-md-5 col-form-label">
                        {result?.training_number_of_hours}
                      </Label>
                      <Label
                        className={`col-md-4 col-form-label ${
                          hdetail != null ? "" : "hidden"
                        }`}
                      >
                        {hresult?.training_number_of_hours}
                      </Label>
                    </Row>
                    {/* <Row className="mb-2">
                                            {this.state.hoursDetail &&
                                                <>
                                                    <Label className="col-md-3 col-form-label"></Label>
                                                    <Label className="col-md-5 col-form-label">
                                                        <span className="text-danger" style={{ fontSize: '12px' }} >Note: Jumlah jam diklat anda tahun ini telah mencapai {this.state.hoursDetail?.total_hours} jam. <a href="javascript:void(0)" onClick={() => this.toggleModal() }>Lihat Detail</a></span>
                                                    </Label>
                                                </>
                                            }
                                        </Row> */}
                    <Row className="mb-2">
                      <Label className="col-md-3 col-form-label">
                        File Pendukung
                      </Label>
                      <Label className="col-md-5 col-form-label">
                        <Preview value={detail?.document} />
                      </Label>
                      <Label
                        className={`col-md-4 col-form-label ${
                          hdetail != null ? "" : "hidden"
                        }`}
                      >
                        <Preview value={hdetail?.document} />
                      </Label>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3">
                        Status Approval <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <CustomSelect
                          name="training_status"
                          errorMessage="Pilih Status Approval"
                          options={[
                            { value: 1, label: "Disetujui" },
                            { value: 2, label: "Ditolak" },
                          ]}
                          placeholder="Pilih Status Approval"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="status_approval_description"
                        className="col-md-3 col-form-label"
                      >
                        Keterangan Approval{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="training_note_approval"
                          placeholder="Keterangan Approval..."
                          type="textarea"
                          errorMessage="Masukkan Keterangan Approval"
                          className="form-control"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>{" "}
                        <Link to={`?index`}>
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <Modal
          isOpen={this.state.modal}
          toggle={() => this.toggleModal()}
          size="lg"
        >
          <ModalHeader toggle={() => this.toggleModal()}>
            Keterangan Jam Diklat
          </ModalHeader>
          <ModalBody>
            <Table>
              <thead>
                <tr>
                  <th>No</th>
                  <th>Diklat</th>
                  <th>Jam Diklat</th>
                </tr>
              </thead>
              <tbody>
                {/* { this.state.hoursDetail.diklat?.map((value, index) => {
                                    return (
                                        <Fragment>
                                            <tr>
                                                <th>{index + 1}</th>
                                                <th>{value.training_type.training_type_name}, {value.training_type.training_type_description}</th>
                                                <th>{value.training_number_of_hours}</th>
                                            </tr>
                                        </Fragment>
                                    )
                                }) } */}
              </tbody>
            </Table>
          </ModalBody>
        </Modal>

        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin ?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil diverifikasi"
          failedTitle="Gagal!"
          failedInfo="Data gagal diverifikasi"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to={`/kepegawaian/diklat/teknis.html`} />
        ) : null}
      </Fragment>
    );
  }
}

export default DetailView;
